import { invoke, isTauri } from '@tauri-apps/api/core';
import { useAuthStore } from 'cloak-auth/src/Client/stores';
import { SensorFirstScanRequestDTO } from 'gen/model';
import { z } from 'zod';

const commandError = z.object({
    code: z.number(),
    message: z.string(),
});

export class TauriDiscoverError extends Error {
    code: number;
    detail?: string;

    constructor(code: number, message?: string, detail?: string) {
        super(message);
        this.code = code;
        this.detail = detail;
    }
}

export const tauriErrorMap = {
    API: 3,
    Config: 1,
    DeviceInfo: 5,
    Installation: 4,
    Internal: 0,
    NoWifi: 6,
    Permission: 2,
};

export async function handleDiscoverTauri(): Promise<SensorFirstScanRequestDTO> {
    const cloak = useAuthStore.getState().keyCloak;
    if (!isTauri() || !cloak) {
        throw new TauriDiscoverError(0, 'Tauri environment or cloak instance is not available');
    }

    try {
        await cloak.updateToken(5);
        const deviceGroup = await invoke<SensorFirstScanRequestDTO>('first_scan', { token: cloak.token });
        return deviceGroup;
    } catch (error) {
        const parsedError = commandError.safeParse(error);
        if (parsedError.success) {
            throw new TauriDiscoverError(parsedError.data.code, parsedError.data.message);
        } else {
            throw new TauriDiscoverError(0, 'Unknown error', String(error));
        }
    }
}
